import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function NavLogoWhite({ theme, ...props }) {
  return (
    <svg
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -7 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Argumentative"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Draft-Intro-1"
          transform="translate(-16.000000, -22.000000)"
          fill="#F5F5F5"
        >
          <g id="Nav-logo" transform="translate(16.000000, 22.000000)">
            <g>
              <g>
                <path
                  d="M15.8097048,0.228725914 C12.9853782,0.228725914 10.6884043,2.53027345 10.6884043,5.35886174 C10.6884043,8.1888119 12.9853782,10.4903594 15.8097048,10.4903594 C18.6326722,10.4903594 20.928287,8.1888119 20.928287,5.35886174 C20.928287,2.53027345 18.6326722,0.228725914 15.8097048,0.228725914"
                  id="Fill-12"
                />
                <path
                  d="M22.2018164,19.9471322 C19.378849,19.9471322 17.081875,22.2486798 17.081875,25.0772681 C17.081875,27.9058564 19.378849,30.2074039 22.2018164,30.2074039 C25.0261429,30.2074039 27.3231169,27.9058564 27.3231169,25.0772681 C27.3231169,22.2486798 25.0261429,19.9471322 22.2018164,19.9471322"
                  id="Fill-13"
                />
                <path
                  d="M0.335711579,12.8858755 C0.335711579,15.7158256 2.63268554,18.0173732 5.4570121,18.0173732 C8.27997951,18.0173732 10.5769535,15.7158256 10.5769535,12.8858755 C10.5769535,10.0572872 8.27997951,7.75573964 5.4570121,7.75573964 C2.63268554,7.75573964 0.335711579,10.0572872 0.335711579,12.8858755 Z"
                  id="Fill-14"
                />
                <path
                  d="M26.1515243,7.76799641 C23.3285569,7.76799641 21.0315829,10.0695439 21.0315829,12.8981322 C21.0315829,15.7280824 23.3285569,18.0282681 26.1515243,18.0282681 C28.9758508,18.0282681 31.2714656,15.7280824 31.2714656,12.8981322 C31.2714656,10.0695439 28.9758508,7.76799641 26.1515243,7.76799641"
                  id="Fill-15"
                />
                <path
                  d="M9.40128337,19.9471322 C6.57831596,19.9471322 4.281342,22.2486798 4.281342,25.0772681 C4.281342,27.9058564 6.57831596,30.2074039 9.40128337,30.2074039 C12.2256099,30.2074039 14.5225839,27.9058564 14.5225839,25.0772681 C14.5225839,22.2486798 12.2256099,19.9471322 9.40128337,19.9471322"
                  id="Fill-16"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

NavLogoWhite.propTypes = {
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
}
